import { render, staticRenderFns } from "./TaxReducersApprovalSettings.vue?vue&type=template&id=7b9eef44"
import script from "./TaxReducersApprovalSettings.vue?vue&type=script&lang=js"
export * from "./TaxReducersApprovalSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports